module.exports = __webpack_public_path__ + "img/compare-blank.ad6b7f0c.png";